import React from 'react'
import { SliderOnboarding } from '@/components/SliderOnboarding'
import { QuestionProps } from '../types'

export const WorkSatisfactionCard = (props: QuestionProps) => {
  const { form, disabled } = props

  return <SliderOnboarding {...form.register('satisfaction_at_work')} disabled={disabled} label="" />
}
